import { DocumentType } from '../../../enums/document-type';
import { pickList } from '../document-type-epic-helpers/pick-list';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {string[]} args.fulfillmentPlanIds
 * @param {object} [args.printer] - can be omitted if doing something like downloading
 * @param {number} [args.pusherTimeoutMs]
 * @param {boolean} [args.isUseCustomerDocType] - optional, defaults to false
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createPickListsAsync = ({ fulfillmentPlanIds, printer, pusherTimeoutMs, isUseCustomerDocType = false }) => {
  const documentCount = fulfillmentPlanIds.length;
  const notification = pickList.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = pickList.getAsyncPrintFailedNotificationProps(1);

  return jobRunner({
    apiRequest: () => Api.generatePickListAsync(fulfillmentPlanIds, isUseCustomerDocType),
    documentCount,
    documentTypeIdentifier: DocumentType.PickList.identifier,
    initialNotification: notification,
    errorNotification,
    ids: fulfillmentPlanIds,
    printer,
    pusherTimeoutMs,
  });
};
